import React, { useState } from "react";
import { Alert, Button, DatePicker, Form, Input, Select } from "antd";
import dayjs from "dayjs";
import viVN from "antd/lib/date-picker/locale/vi_VN";
import "dayjs/locale/vi";
import MemberAvatar from "../member-avatar/MemberAvatar";

const labels = { name: "Tên của bạn", mobile: "Số điện thoại", birth_date: "Ngày sinh", gender: "Giới tính", address: "Địa chỉ", email: "Địa chỉ email" };
const fieldNames = Object.keys(labels);
const maxLengths = { name: 100, email: 254, address: 500 };

export default function CustomerProfile({ member, onSave, saving = false, error, notice }) {
  const [editing, setEditing] = useState(false);
  const [openControl, setOpenControl] = useState(null);
  const [form] = Form.useForm();
  const customer = member.customer;
  const editable = member.editableFields || [];
  const startEditing = () => {
    form.setFieldsValue(Object.fromEntries(fieldNames.map((field) => [field, customer[field] || ""])));
    setEditing(true);
  };
  const save = async (values) => {
    const changes = Object.fromEntries(editable.filter((field) => (values[field] || "").trim() !== (customer[field] || ""))
      .map((field) => [field, (values[field] || "").trim()]));
    if (!Object.keys(changes).length) { setEditing(false); return; }
    if (await onSave(changes)) setEditing(false);
  };
  return <section aria-label="Thông tin người dùng" className="member-profile" onKeyDownCapture={(event) => {
    if (event.key === "Escape" && openControl) {
      event.stopPropagation();
      setOpenControl(null);
    }
  }}>
    <div className="member-profile-heading">
      <MemberAvatar member={member} /><div className="member-profile-identity"><h2>{member.name}</h2><p className="member-muted">{customer.email || member.tierLabel}</p></div>
    </div>
    {error && <Alert role="alert" type="error" showIcon message={error} />}
    {notice && !editing && <Alert role="status" type="success" showIcon message={notice} />}
    {editing ? <Form form={form} layout="vertical" onFinish={save} className="member-profile-form" disabled={saving}>
      {fieldNames.map((field) => {
        const canEdit = editable.includes(field);
        const rules = field === "name" ? [{ required: true, whitespace: true, message: "Vui lòng nhập tên của bạn." }]
          : field === "email" ? [{ type: "email", message: "Địa chỉ email không hợp lệ." }] : [];
        return <Form.Item key={field} label={labels[field]} name={field} rules={canEdit ? rules : []}
          {...(field === "birth_date" ? {
            getValueProps: (value) => ({ value: value && dayjs(value).isValid() ? dayjs(value).locale("vi") : null }),
            getValueFromEvent: (date) => date ? date.format("YYYY-MM-DD") : "",
          } : {})} className={field === "address" || field === "email" ? "member-field-wide" : ""}>
          {field === "gender" ? <Select open={openControl === "gender"} onDropdownVisibleChange={(open) => setOpenControl(open ? "gender" : null)} disabled={saving || !canEdit} popupClassName="member-profile-select-popup"
            options={[{ value: "", label: "Chưa cập nhật" }, { value: "male", label: "Nam" }, { value: "female", label: "Nữ" }, { value: "other", label: "Khác" }]} />
            : field === "birth_date" ? <DatePicker open={openControl === "birth_date"} onOpenChange={(open) => setOpenControl(open ? "birth_date" : null)} format="DD/MM/YYYY" locale={viVN} placeholder="Chọn ngày sinh"
              popupClassName="member-profile-date-popup" disabled={saving || !canEdit} allowClear
              disabledDate={(date) => date && date.isAfter(dayjs(), "day")} />
            : <Input type={field === "email" ? "email" : "text"} maxLength={maxLengths[field]} disabled={!canEdit || saving} autoComplete={field === "name" ? "name" : field === "email" ? "email" : "off"} />}

        </Form.Item>;
      })}
      <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
    </Form> : <dl className="member-profile-fields">
      {fieldNames.map((field) => <div key={field} className={field === "address" || field === "email" ? "member-field-wide" : ""}><dt>{labels[field]}</dt><dd>{(field === "gender" ? customer.gender_label : field === "birth_date" && customer[field] && dayjs(customer[field]).isValid() ? dayjs(customer[field]).format("DD/MM/YYYY") : customer[field]) || "Chưa cập nhật"}</dd></div>)}
    </dl>}
    <p className="member-muted">Thông tin được bảo vệ bằng mã PIN của bạn.{editing && " Số điện thoại xác thực không thể thay đổi tại đây."}</p>
    <div className="member-profile-actions">
      {editing ? <><Button key="save" type="primary" aria-label="Lưu thay đổi" aria-busy={saving} onClick={() => form.submit()} loading={saving}>Lưu</Button><Button onClick={() => setEditing(false)} disabled={saving}>Hủy</Button></>
        : editable.length > 0 && onSave && <Button key="edit" className="member-profile-edit" aria-label="Chỉnh sửa" onClick={startEditing} disabled={saving}>Chỉnh sửa</Button>}
    </div>
  </section>;
}
